import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getPhysicalConnectionsRaw = ({ assetPhysicalConnection }) => ({
    data: assetPhysicalConnection?.physicalConnections?.data,
    loadingStatus: assetPhysicalConnection?.physicalConnections?.loadingStatus,
    error: assetPhysicalConnection?.physicalConnections?.error,
    errorCode: assetPhysicalConnection?.physicalConnections?.error?.statusCode ||
        assetPhysicalConnection?.physicalConnections?.error?.status
});

const getPhysicalConnectionsErrorData = createErrorDataSelector(getPhysicalConnectionsRaw);

export const getModel = createSelector(
    [getPhysicalConnectionsRaw, getPhysicalConnectionsErrorData],
    (physicalConnections, physicalConnectionsErrorData) => ({
        physicalConnections,
        physicalConnectionsErrorData
    })
);
